import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Users, Stethoscope, Hospital, CalendarDays, FlaskConical, Pill, Bed, Ambulance, Settings, ShieldCheck, UserCog } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CFG = [
  { k: "users", label: "Users", icon: Users, color: "text-teal-700" },
  { k: "doctors", label: "Doctors", icon: Stethoscope, color: "text-cyan-700" },
  { k: "hospitals", label: "Hospitals", icon: Hospital, color: "text-slate-700" },
  { k: "appointments", label: "Appointments", icon: CalendarDays, color: "text-emerald-700" },
  { k: "lab_bookings", label: "Lab bookings", icon: FlaskConical, color: "text-purple-700" },
  { k: "orders", label: "Medicine orders", icon: Pill, color: "text-amber-700" },
  { k: "bed_bookings", label: "Bed reservations", icon: Bed, color: "text-red-700" },
  { k: "ambulance_bookings", label: "Ambulance dispatches", icon: Ambulance, color: "text-red-700" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="text-xs font-semibold uppercase tracking-widest text-teal-700">Admin</div>
      <div className="flex items-start justify-between flex-wrap gap-3 mt-1">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold">MedHOne Control</h1>
          <p className="text-slate-600 text-sm">Platform-wide statistics.</p>
        </div>
        <Link to="/admin/hospitals">
          <Button data-testid="admin-hosp-link" className="bg-red-600 hover:bg-red-500 text-white">
            <Settings className="w-4 h-4 mr-2" /> Hospitals
          </Button>
        </Link>
        <Link to="/admin/labs">
          <Button data-testid="admin-labs-link" className="bg-emerald-600 hover:bg-emerald-500 text-white">
            <Settings className="w-4 h-4 mr-2" /> Labs
          </Button>
        </Link>
        <Link to="/admin/pharmacies">
          <Button data-testid="admin-pharm-link" className="bg-amber-600 hover:bg-amber-500 text-white">
            <Settings className="w-4 h-4 mr-2" /> Pharmacies
          </Button>
        </Link>
        <Link to="/admin/partners">
          <Button data-testid="admin-partners-link" className="bg-teal-600 hover:bg-teal-500 text-white">
            <UserCog className="w-4 h-4 mr-2" /> Partner Access
          </Button>
        </Link>
        <Link to="/admin/approvals">
          <Button data-testid="admin-approvals-link" variant="outline">
            <ShieldCheck className="w-4 h-4 mr-2" /> Approvals
          </Button>
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {CFG.map((c) => (
          <Card key={c.k} className="p-5 rounded-2xl" data-testid={`stat-${c.k}`}>
            <c.icon className={`w-6 h-6 ${c.color} mb-2`} />
            <div className="text-xs uppercase tracking-wider text-slate-500">{c.label}</div>
            <div className="font-mono text-3xl font-bold">{stats[c.k] ?? 0}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
